import React, { memo } from 'react';

export const DropCrossedOutSmall: React.FC = memo(() => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.85303 10.9199V6.73276C2.85303 6.58142 2.91315 6.43627 3.02017 6.32925C3.12719 6.22223 3.27233 6.16211 3.42368 6.16211H14.8367C14.9881 6.16211 15.1332 6.22223 15.2402 6.32925C15.3473 6.43627 15.4074 6.58142 15.4074 6.73276V10.9199C15.4074 16.9118 10.3214 18.8948 9.30853 19.23C9.19346 19.2726 9.06694 19.2726 8.95187 19.23C7.93896 18.8948 2.85303 16.9118 2.85303 10.9199Z"
      stroke="#919395"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2.5 2.5"
    />
    <path
      d="M18.25 7.92308C18.25 4.02885 13.75 1 13.75 1C13.75 1 9.25 4.02885 9.25 7.92308C9.25 9.07065 9.72411 10.1712 10.568 10.9827C11.4119 11.7941 12.5565 12.25 13.75 12.25C14.9435 12.25 16.0881 11.7941 16.932 10.9827C17.7759 10.1712 18.25 9.07065 18.25 7.92308Z"
      fill="white"
    />
    <path
      d="M14.2056 10.476C14.7556 10.3863 15.2631 10.1347 15.6581 9.75593C16.053 9.37713 16.316 8.88979 16.4106 8.36118"
      fill="white"
    />
    <path
      d="M15.4408 8.86542C15.8941 8.78857 16.3124 8.5729 16.638 8.24817C16.9635 7.92345 17.1803 7.50568 17.2583 7.05253M18.7744 6.67697C18.7744 3.33865 15.0652 0.742188 15.0652 0.742188C15.0652 0.742188 11.356 3.33865 11.356 6.67697C11.356 7.66072 11.7468 8.60418 12.4424 9.2998C13.138 9.99541 14.0814 10.3862 15.0652 10.3862C16.0489 10.3862 16.9924 9.99541 17.688 9.2998C18.3836 8.60418 18.7744 7.66072 18.7744 6.67697Z"
      stroke="#21282B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
